module.exports = __webpack_public_path__ + "static/education_quiz@2x-67eb963032a5da8925c60ca6c852d562.png";